export default __webpack_public_path__ + "static/upper1_2-f3d2259755e010a9bfae071876963cbe.jpg";